import gql from 'graphql-tag';

export default gql`
  fragment preleadContactCreateActivityFragment on PreleadContactCreateActivity {
    preleadContactFirstName
    preleadContactLastName
  }
`;
